import type {DemandDataPerMaterial} from '@domain/material-demand'
import {MaterialType} from '@domain/materials'
import type {Material} from '@domain/materials'
import {formatFloat} from '@hconnect/uikit/src/common/utils/unitFormatting'

import type {AssetCapacity} from '../interfaces'

export const getPercentageInDecimal = (value: number, total: number, decimalPlaces = 1) => {
  const fraction = value / total
  return `${formatFloat(fraction * 100, decimalPlaces)}%`
}

export const getProducedPerMaterial = (
  assetsCapacity: Record<string, AssetCapacity>
): Record<string, number> => {
  const assetProductionKPIs = Object.values(assetsCapacity).map((assetCapacity) =>
    Object.entries(assetCapacity.materials)
  )

  return assetProductionKPIs.reduce<Record<string, number>>((result, materialCapacityEntries) => {
    materialCapacityEntries.forEach(([materialId, {producedTonnes}]) => {
      result[materialId] = (result[materialId] ?? 0) + producedTonnes
    })
    return result
  }, {})
}

const getProducedMaterialsIds = (
  producedByMaterialId: Record<string, number>,
  materialsById: Record<string, Material>,
  types: MaterialType[]
): string[] => {
  return Object.keys(producedByMaterialId).filter((materialId) => {
    const material = materialsById[materialId]
    if (!material) {
      throw new Error(`BUG: Material with id ${materialId} does not exist in materialsById`)
    }

    return types.includes(material.type)
  })
}

export const getProducedOrForecastedMaterialsIds = (
  producedByMaterialId: Record<string, number>,
  forecastedMaterials: DemandDataPerMaterial,
  materialsById: Record<string, Material>,
  types: MaterialType[]
): string[] => {
  return [
    ...new Set([
      ...getProducedMaterialsIds(producedByMaterialId, materialsById, types),
      ...Object.keys(forecastedMaterials)
    ])
  ]
}
